<template>
  <div class="container ac-2">
    <NavTop :title="name" :type="navid" v-if="navid != undefined" class="mb-10"/>
    <div class="main gap-10">
      <slot></slot>
    </div>
    <NavBottom :tabId="menuid" v-if="menuid != undefined"/>
  </div>
</template>

<script>
export default {
  name: 'MainView',
  props: {
    name:{
      type:String,
      default:"",
    },
    navid:{
      type:Number,
      default:undefined,
    },
    menuid:{
      type:Number,
      default:undefined,
    },
  },
  mounted() {

  },
  data () {
    return {

    }
  },
  methods : {

  },
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">

</style>
